import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const SendToGoal = (data: any) =>
    request({
        url: ApiURL.Query.SendToGoal,
        method: RequestType.POST,
        data: data,
    });

const GoalQuery = {
    SendToGoal,
};

export default GoalQuery;